"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const utilities_css = require("../utilities/css.js");
const Icon$1 = "_Icon_j5977_5";
const Svg = "_Svg_j5977_55";
const styles = {
  Icon: Icon$1,
  Svg
};
function Icon({ symbol: Symbol2, size = "md", color, accessibilityLabel }) {
  const style = __spreadValues(__spreadValues({}, utilities_css.getComponentThemeToken("icon", "color", "color.text", color)), utilities_css.getResponsiveDesignToken("icon", "size", "size.icon", size));
  return React.createElement("span", {
    className: styles.Icon,
    style
  }, React.createElement(Symbol2, {
    className: styles.Svg,
    focusable: "false",
    role: "img",
    title: accessibilityLabel,
    "aria-hidden": !accessibilityLabel ? "true" : void 0
  }));
}
exports.Icon = Icon;
